function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Atlantbh");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 1440,
  height: 60,
  rx: 6
}), /*#__PURE__*/React.createElement("filter", {
  x: "-0.2%",
  y: "-5.0%",
  width: "100.4%",
  height: "120.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feMorphology", {
  radius: 3,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 6,
  in: "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "0.0296680498 0.365454545 11.0743983 0.365454545 11.0743983 17.5821364 0.0296680498 17.5821364"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Sign-in/Sign-up",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Forgot-password",
  transform: "translate(-132.000000, -17.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#F1F7FF",
  x: 0,
  y: 0,
  width: 1440,
  height: 1024
}), /*#__PURE__*/React.createElement("g", {
  id: "Navigation/Demo/Header"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Background",
  x: 0,
  y: 0,
  width: 1440,
  height: 60
}), /*#__PURE__*/React.createElement("g", {
  id: "UI/Shadow/3",
  fill: "black",
  fillOpacity: 1
}, /*#__PURE__*/React.createElement("g", {
  id: "SHADOW"
}, /*#__PURE__*/React.createElement("use", {
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}))), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: 0,
  y: 0,
  width: 1440,
  height: 60
}), /*#__PURE__*/React.createElement("g", {
  id: "Logo",
  transform: "translate(132.000000, 17.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-22"
}, /*#__PURE__*/React.createElement("path", {
  d: "M100.163763,6.86304545 L100.163763,19.0180455 L102.803307,19.0180455 L102.803307,12.0139545 C103.752685,11.1312273 104.689739,10.6894091 105.612643,10.6894091 C106.761481,10.6894091 107.335672,11.2675909 107.335672,12.4230455 L107.335672,19.0180455 L109.975216,19.0180455 L109.975216,12.4530455 C109.975216,9.85531818 108.76978,8.55804545 106.358452,8.55804545 C105.078618,8.55804545 103.892809,8.93622727 102.803307,9.69304545 L102.803307,8.55804545 L102.411232,6.86304545 L100.163763,6.86304545 Z",
  id: "Fill-1",
  fill: "#333333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.3242324,16.8856818 C91.5273029,16.8856818 90.8266805,16.7893182 90.2228216,16.5965909 L90.2228216,11.2870455 C90.9540249,10.9288636 91.763278,10.7493182 92.6533195,10.7493182 C94.1604564,10.7493182 94.9140249,11.6684091 94.9140249,13.5084091 C94.9140249,15.7597727 94.0509129,16.8856818 92.3242324,16.8856818 M92.6629046,8.55795455 C91.8258091,8.55795455 91.0138174,8.72431818 90.2228216,9.05477273 L90.2228216,8.55795455 L89.7846473,6.86295455 L87.583278,6.86295455 L87.583278,18.5893182 C89.2360166,18.8752273 90.7801245,19.0179545 92.2156017,19.0179545 C95.7547718,19.0179545 97.5243568,17.2052273 97.5243568,13.5793182 C97.5243568,10.2315909 95.9044813,8.55795455 92.6629046,8.55795455",
  id: "Fill-3",
  fill: "#333333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.751332,6.3965 C13.8563942,6.3965 15.73461,7.39377273 16.9350249,8.93877273 L16.83461,8.6065 L16.6164357,7.97377273 L16.3685934,7.33377273 L16.0919959,6.68831818 L15.7889253,6.03922727 L15.4589253,5.38695455 L15.1038216,4.73422727 L14.7236141,4.08104545 L14.3205851,3.42968182 L13.8947344,2.7815 L13.4465187,2.1365 L12.9782199,1.49740909 L12.8184689,1.29059091 C12.4647344,1.25786364 12.1064357,1.24104545 11.7453983,1.24104545 C5.27593776,1.24104545 4.56431535e-05,6.49559091 4.56431535e-05,12.9383182 C4.56431535e-05,19.3801364 5.27593776,24.6346818 11.7453983,24.6346818 C17.9428257,24.6346818 23.0448174,19.8115 23.4615394,13.7419545 C20.0812075,16.8396818 15.5301286,19.9892273 10.9534896,19.3983182 C7.71784647,19.0051364 5.19880083,16.2474091 5.19880083,12.9219545 C5.19880083,9.32740909 8.14187137,6.3965 11.751332,6.3965",
  id: "Fill-5",
  fill: "#333333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.069917,14.5348182 C33.8014938,14.5348182 33.1675104,14.9334545 33.1675104,15.7302727 C33.1675104,16.5270909 33.6987967,16.9252727 34.7613693,16.9252727 C35.8371784,16.9252727 36.7495851,16.6534545 37.5004149,16.1089091 L37.5004149,14.7334545 C36.8367635,14.6016364 36.0265975,14.5348182 35.069917,14.5348182 M30.5275104,15.7598182 C30.5275104,13.6152727 32.0419502,12.5420909 35.069917,12.5420909 C35.9804979,12.5420909 36.789751,12.6093636 37.5004149,12.7416364 L37.5004149,12.0543636 C37.5004149,11.1170909 36.5943983,10.6493636 34.7814523,10.6493636 C33.6390041,10.6493636 32.5038589,10.8157273 31.3741909,11.1475455 L31.3741909,9.05481818 C32.5038589,8.72436364 33.6390041,8.558 34.7814523,8.558 C38.3539419,8.558 40.1399585,9.70618182 40.1399585,12.0057273 L40.1399585,19.018 L38.8058091,19.018 L37.6692946,18.2807273 C36.760083,18.7716364 35.7906224,19.018 34.7613693,19.018 C31.9387967,19.018 30.5275104,17.9320909 30.5275104,15.7598182",
  id: "Fill-7",
  fill: "#333333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.7240456,6.86304545 L44.6762033,6.86304545 L45.0751245,8.55804545 L47.5047095,8.55804545 L47.5047095,10.6494091 L45.3635892,10.6494091 L45.3635892,15.4612273 C45.3635892,16.4375909 45.785332,16.9253182 46.6288174,16.9253182 L47.5047095,16.9253182 L47.5047095,19.0180455 L45.3535477,19.0180455 C43.5999378,19.0180455 42.7240456,18.0785 42.7240456,16.1980455 L42.7240456,6.86304545 Z",
  id: "Fill-9",
  fill: "#333333"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-11",
  fill: "#333333",
  points: "50.1559834 19.0181364 52.7959834 19.0181364 52.7959834 8.55768182 52.378805 6.86313636 50.1559834 6.86313636"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.9782075,14.5348182 C58.7097842,14.5348182 58.0758008,14.9334545 58.0758008,15.7302727 C58.0758008,16.5270909 58.6070871,16.9252727 59.6696598,16.9252727 C60.7459253,16.9252727 61.6578755,16.6534545 62.4091618,16.1089091 L62.4091618,14.7334545 C61.7450539,14.6016364 60.934888,14.5348182 59.9782075,14.5348182 M55.4358008,15.7598182 C55.4358008,13.6152727 56.9506971,12.5420909 59.9782075,12.5420909 C60.888332,12.5420909 61.6989544,12.6093636 62.4091618,12.7416364 L62.4091618,12.0543636 C62.4091618,11.1170909 61.5026888,10.6493636 59.6901992,10.6493636 C58.5472946,10.6493636 57.4126058,10.8157273 56.2820249,11.1475455 L56.2820249,9.05481818 C57.4126058,8.72436364 58.5472946,8.558 59.6901992,8.558 C63.2622324,8.558 65.0487054,9.70618182 65.0487054,12.0057273 L65.0487054,19.018 L63.7136432,19.018 L62.5775851,18.2807273 C61.6683734,18.7716364 60.6993693,19.018 59.6696598,19.018 C56.8475436,19.018 55.4358008,17.9320909 55.4358008,15.7598182",
  id: "Fill-13",
  fill: "#333333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.6884772,19.0181364 L67.6884772,8.55768182 L69.7300954,8.55768182 L70.0587261,9.89222727 C71.3285187,9.00222727 72.6024191,8.55768182 73.883166,8.55768182 C76.2940373,8.55768182 77.4999295,9.85540909 77.4999295,12.4531364 L77.4999295,19.0181364 L74.8603859,19.0181364 L74.8603859,12.4231364 C74.8603859,11.2676818 74.2852822,10.6895 73.136444,10.6895 C72.2144523,10.6895 71.2773983,11.1308636 70.3289336,12.0140455 L70.3289336,19.0181364 L67.6884772,19.0181364 Z",
  id: "Fill-15",
  fill: "#333333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.13961,6.86304545 L82.0917676,6.86304545 L82.4911452,8.55804545 L84.9216432,8.55804545 L84.9216432,10.6494091 L82.7791535,10.6494091 L82.7791535,15.4612273 C82.7791535,16.4375909 83.2018091,16.9253182 84.0452946,16.9253182 L84.9216432,16.9253182 L84.9216432,19.0180455 L82.7695685,19.0180455 C81.0168714,19.0180455 80.13961,18.0785 80.13961,16.1980455 L80.13961,6.86304545 Z",
  id: "Fill-17",
  fill: "#333333"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-21",
  transform: "translate(13.236515, 0.089227)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-20"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.0296680498,0.365318182 C5.89983402,1.07122727 10.5490456,5.81940909 11.0743983,11.7175909 L9.32626556,13.3025909 L9.00630705,13.5866818 L8.68041494,13.8685 L8.34904564,14.1485 L8.01219917,14.4262273 L7.67033195,14.7003182 L7.32298755,14.9703182 L6.97153527,15.2348636 L6.61551867,15.4944091 L6.25539419,15.7480455 L5.89070539,15.9939545 L5.52373444,16.2325909 L5.15219917,16.4635 L4.77746888,16.6848636 L4.40136929,16.8966818 L4.02161826,17.0985 L3.63958506,17.2894091 L3.25618257,17.4694091 L2.99556017,17.5821364 C7.08062241,13.7798636 4.84958506,6.51395455 0.0296680498,0.365318182",
  id: "Fill-19",
  fill: "#333333",
  mask: "url(#mask-4)"
})))))));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "110px",
    height: "25px",
    viewBox: "0 0 110 25",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.7831ef17.svg";
export { ForwardRef as ReactComponent };